//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/LayoutDefinition.js";
import "../no/BasePart.js";
let d=[[[0,"Current",0,"Layout",0]],[[["name","layout_arrangement","fit_all_views"],"Create",{R_:{layout:"Layout"}},3,0],[["arrangement","layout_arrangement"],"NewLayoutDefinition",{},1,0],[["journal_identifier"],"FindObject",{R_:{found:"Layout"}},1,0],[["leftViewName","rightViewname","layout","leftView","rightView"],"CreateSplitScreenLayoutAndNamedViews",{},2,0],[["layout"],"DestroySplitScreenLayoutAndNamedViews",{},1,0],[["layout"],"ChangeLayout",{},1,0],[["layout","leftViewName","rightViewName"],"RenameViewsInSplitScreenLayout",{},3,0],[["layout","removeOldLayoutCache","ignoreNewLayoutCache"],"ChangeLayoutWithOptions",{},3,0]],[]];
SPLM.LayoutCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.LayoutCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;